export default __webpack_public_path__ + "static/media/search-icon.1d49ca56.png";